import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axiosInstance from "@/Axios/ConfiguredAxios";
import { siteConfigurationApi } from "@/apis/apis";

export const fetchSiteConfiguration = createAsyncThunk(
  "site/configuration",
  async () => {
    const response = await axiosInstance.get(siteConfigurationApi);
    return response.data.data;
  }
);

const initialState = {
  locales: [],
};

const siteConfigurationSlice = createSlice({
  name: "siteConfigurationSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSiteConfiguration.fulfilled, (state, action) => {
      state.locales = action.payload.locales;
    });
  },
});

export default siteConfigurationSlice.reducer;
